import React from 'react'
import '../index.scss'

const Detail: React.FC = () => {
  return <div className="animate ~h-7 ~w-quarter ~rounded-sm" />
}

export default Detail
